import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Payment } from '@mercadopago/sdk-react';
import { toast } from 'react-toastify';
import { mercadoPagoApiUrl, mercadoPagoProcesamientoUrl } from '../utils/helpers/enviroment.helpers';


/**
 * Componente presentacional para renderizar el Payment Brick de Mercado Pago
 * Este componente es "tonto" y solo se encarga de la presentación del brick
 * 
 * @param {Object} props
 * @param {string} props.preferenceId - ID de la preferencia de Mercado Pago
 * @param {(status: 'approved'|'rejected'|'pending') => void} [props.onPaymentResult]
 */
const MercadoPagoBrick = ({ preferenceId, onPaymentResult, idPago, tarifa }) => {
  const [mostrarBrick, setMostrarBrick] = useState(true);
  const [error, setError] = useState(null);
  
  // Ref para verificar si el componente está montado
  const isMountedRef = useRef(true);

  // Cleanup: marcar como desmontado cuando el componente se desmonte
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
 
  // Debug: verificar que el preferenceId se esté recibiendo
  //console.log('MercadoPagoBrick - preferenceId recibido:', preferenceId);

  const initialization = {
    amount: tarifa,
    preferenceId: preferenceId
  };

  // Configuración de customización del brick (opcional)
  const customization = {
    paymentMethods: {
      creditCard: "all",
      prepaidCard: "all",
      debitCard: "all",
      mercadoPago: "all",
    },
  };

  /**
   * Callback que se ejecuta cuando el usuario envía el formulario de pago
   * @param {Object} formData - Datos del formulario de pago
   */
 

   const onSubmit = ({ selectedPaymentMethod, formData }) => {
    if (isMountedRef.current) {
      setError(null);
    }
    
    return new Promise((resolve, reject) => {
      fetch(`${window.__CONFIG__.apiMercadoPago}${window.__CONFIG__.mercadoPagoProcesamientoUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...formData,
          idPago: idPago
        }),
      })
      // MANEJA LOS ERRORES HTTP (ej. 400, 500 etc)
      // Si la respuesta NO es 'ok' rechaza la promesa
      .then((response) => {
        if (!response.ok) {
          // error backend
          return response.json().then(errorData => {
            if (isMountedRef.current) {
              setMostrarBrick(true);
            }
            reject(errorData); 
          });
        }
        return response.json();
      })
      .then((resp) => {
        if (!isMountedRef.current) return;
        
        const estado = (resp?.status || resp?.estado || '').toString().toLowerCase();
        //console.log('respuesta del pago:', resp);
        
        // Notificar al contenedor (esto está bien)
        if (onPaymentResult && typeof onPaymentResult === 'function') {
          if (estado === 'approved' || estado === 'rejected' || estado === 'pending') {
            onPaymentResult(estado);
          }
        }
  
        if (estado === 'rejected') {
          //PAGO RECHAZADO (con HTTP 200 OK)
          if (isMountedRef.current) {
            setMostrarBrick(true);
            toast.error("El pago fue rechazado. Por favor, revise los datos e intente nuevamente.");
          }
          
        
          reject(resp); 
          
        } else {
          // APROBADO O PENDIENTE: Éxito
          if (isMountedRef.current) {
            setMostrarBrick(false);
            setError(null); 
          }
          //  resolve() cierra el brick
          resolve(); 
        }
      })
      .catch((error) => {
        
        if (isMountedRef.current) {
          
          setError(error);
          setMostrarBrick(true);
          toast.error("Hubo un error al procesar el pago. Por favor, intente nuevamente.");
        }
        
        //  USAR REJECT() PARA QUE EL BRICK SE QUEDE ABIERTO
        reject(error); 
      });
    });
  };

 
  // Validar que tengamos un preferenceId antes de renderizar
  if (!preferenceId) {
    return (
      <div className="mercadopago-brick-container">
        <div className="alert alert-warning">
          <strong>Error:</strong> No se pudo cargar la información de pago. Por favor, intente nuevamente.
        </div>
      </div>
    );
  }

  return (
    <div className="mercadopago-brick-container">
      {/* Mostrar mensaje de error si existe pero mantener el brick visible */}
      {error && (
        <div className="alert alert-danger mb-3" role="alert">
          <strong>Error:</strong> {error.message}
        </div>
      )}

      { mostrarBrick && (
        <Payment
          initialization={initialization}
          customization={customization}
          onSubmit={onSubmit}
        //  onError={onError}
        //  onReady={onReady}
        />
      )} 
    </div>
  );
};

export default MercadoPagoBrick;
